import styled from "styled-components"
import image from "assets/images/tutorial-bg-image.png"

export const TutorialWrapper = styled.div`
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  background: background: linear-gradient(52deg, rgba(23, 18, 45, 0.00) 48.92%, #0D0820 100%), linear-gradient(180deg, #191330 0.01%, #121530 40%, #10284F 99.99%);
  background-image: url(${image});
  background-size: cover;
  overflow-y: auto;
`

export const PageSubtitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 160%;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 4px;
`

export const FeatureCard = styled.div`
  background: #000000;
  border-radius: 24px;
  max-height: 135px;
  min-height: 90px;
  padding: 12px 12px 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  width: 100%;
  flex: 1 1 0;
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 199px;
  z-index: 4;
  position: relative;
`

export const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  line-height: 140%;
  color: #ffffff;
  margin: 0;
`

export const CardDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 160%;
  color: rgba(255, 255, 255, 0.8);
`

export const CardImageContainer = styled.div`
  position: absolute;
  width: 171px;
  right: 12px;
  z-index: 1;
  height: calc(100% - 16px);
  background: #000000;
  border-radius: 16px;
`

export const InnerImageContent = styled.div`
  position: absolute;
  top: 2px;
  right: 2px;
  bottom: 3px;
  left: 0;
  border-radius: 0 14px 14px 0;
  overflow: hidden;
  z-index: 1;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      256deg,
      rgba(0, 0, 0, 0) 4%,
      rgba(0, 0, 0, 0) 46.4%,
      rgba(0, 0, 0, 0.33) 64.61%,
      rgba(0, 0, 0, 1) 79.36%
    );
    z-index: 2;
    pointer-events: none;
  }
`

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  border-radius: 16px;
  object-position: calc(50% - 1px) calc(50% + 3px);
`

export const FeatureCards = styled.div`
  --bottom-cta-height: 84px;

  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: auto;
  padding: 24px;
  flex: 1 1 0;
  padding-bottom: var(--bottom-cta-height);
`

export const BottomCTA = styled.div`
  z-index: 1000;
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: var(--app-max-width);
  display: flex;
  padding: var(--spacing_m, 12px) var(--spacing_xl, 24px)
    var(--spacing_xl, 24px) var(--spacing_xl, 24px);

  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 100%
  );
  backdrop-filter: blur(5px);
`

export const BetaTag = styled.div`
  border-radius: 100px;
  border: 1px solid
    var(--Schemes-Primary-container-Primary-Container-Variant, #cceded);
  background: var(--Primitive-White, #fff);

  display: inline-flex;
  height: 22px;
  padding: 2px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-size: 12px;
  font-weight: 600;
  color: var(
    --Schemes-Primary-container-On-Primary-Container-On-Primary-Container,
    #023648
  );
`
